module.exports = __webpack_public_path__ + "assets/img/Future_Friocourt.95a15749-ps.jpg";